import styled from "styled-components";

export const Clickable = styled.div`
    display: flex;
    align-items: center;
    justify-content: ${props => props.horizontalAlignment};
    cursor: pointer;
    
    transition: background-color 0.2s ease;
    :hover {
        color: #3b7433;
        border-color: #3b7433;
    }
`;